<template lang="pug">
div.modal-content
  form(@submit.prevent="submitForm")
    div.modal-header
      h5.modal-title(v-text="title")
      button.close(type="button", @click.prevent="close"): icon(icon="times")
    div.modal-alert
      div.alert.alert-danger(v-if="error_message", v-text="error_message")
      div.alert.alert-success(v-if="success_message", v-text="success_message")
    div.modal-body
      div.modal-loading(v-show="loading")
        div.lds-roller
          div
          div
          div
          div
          div
          div
          div
          div
      slot
    div.modal-footer
      button.btn.btn-danger(type="button", @click.prevent="close") Cancel
      button.btn.btn-success(type="submit", v-text="buttonText", :disabled="loading")
</template>

<script>
import {get} from 'lodash-es'

export default {
  props: {
    title: {
      type: String
    },
    method: {
      type: String,
      default: "POST"
    },
    endpoint: {
      required: true,
      type: String
    },
    data: {
      required: true,
      type: Object
    },
    buttonText: {
      type: String,
      default: 'Submit'
    }
  },
  data: () => ({
    loading: false,
    request: false,
    error_message: undefined,
    success_message: undefined
  }),
  methods: {
    submitForm() {
      this.loading = true;
      this.error_message = '';
      this.success_message = '';
      this.$emit('errors', [])

      this.$http({
        method: this.method,
        url: this.endpoint,
        data: this.data
      })
      .then(response => {
        this.success_message = get(response, 'data.message', false);
        this.close()
        this.$emit('success', get(response, 'data.item'))
        let currentRoute = this.$router.currentRoute
        currentRoute.query.nocache = Math.random()
        this.$router.push(currentRoute)
      })
      .catch(error => {
        if ( get(error, 'response.status') === 422 ) {
          this.error_message = 'Please correct the fields highlighted in red below'
          this.$emit('errors', get(error, 'response.data.errors', {}))
        } else {
          this.error_message = get(error, 'response.data.error', get(error, 'response.data.message', error.message))
        }
      })
      .finally(() => {
        this.loading = false
      })
    },
    close() {
      this.$parent.$emit('close')
    }
  }
}
</script>

<style>
.modal-alert,
.modal-alert .alert {
  border-radius: 0;
  margin: 0;
}
.modal-footer {
  background-color: #f1f1f1;
}

.modal-loading {
  position:absolute;
  background: rgba(255,255,255,0.5);
  top:0;
  left:0;
  width:100%;
  height:100%;
  z-index:5;
}

.lds-roller {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
  position:absolute;
  top:50%;
  left:50%;
  margin: -32px 0 0 -32px;
}
.lds-roller div {
  animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  transform-origin: 32px 32px;
}
.lds-roller div:after {
  content: " ";
  display: block;
  position: absolute;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #ccc;
  margin: -3px 0 0 -3px;
}
.lds-roller div:nth-child(1) {
  animation-delay: -0.036s;
}
.lds-roller div:nth-child(1):after {
  top: 50px;
  left: 50px;
}
.lds-roller div:nth-child(2) {
  animation-delay: -0.072s;
}
.lds-roller div:nth-child(2):after {
  top: 54px;
  left: 45px;
}
.lds-roller div:nth-child(3) {
  animation-delay: -0.108s;
}
.lds-roller div:nth-child(3):after {
  top: 57px;
  left: 39px;
}
.lds-roller div:nth-child(4) {
  animation-delay: -0.144s;
}
.lds-roller div:nth-child(4):after {
  top: 58px;
  left: 32px;
}
.lds-roller div:nth-child(5) {
  animation-delay: -0.18s;
}
.lds-roller div:nth-child(5):after {
  top: 57px;
  left: 25px;
}
.lds-roller div:nth-child(6) {
  animation-delay: -0.216s;
}
.lds-roller div:nth-child(6):after {
  top: 54px;
  left: 19px;
}
.lds-roller div:nth-child(7) {
  animation-delay: -0.252s;
}
.lds-roller div:nth-child(7):after {
  top: 50px;
  left: 14px;
}
.lds-roller div:nth-child(8) {
  animation-delay: -0.288s;
}
.lds-roller div:nth-child(8):after {
  top: 45px;
  left: 10px;
}
@keyframes lds-roller {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>